import { TDeviceType } from '@cian/ui-kit';
import { ca } from '@cian/analytics';
import { PAGE_TYPE } from '../../constants/pageType';
import { getSiteType } from '../../utils/getSiteType';

export const trackClickShowPhone = (deviceType: TDeviceType, userId: number | null) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click',
    label: 'Banner_Call_us',
    user: {
      userId,
    },
    page: {
      pageType: PAGE_TYPE,
      siteType: getSiteType(deviceType),
      extra: {
        banner_location: 'ListingAgents',
      },
    },
  });
};

export const trackShowBanner = (deviceType: TDeviceType, userId: number | null) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Show_sopr',
    label: 'Banner_Call_us',
    user: {
      userId,
    },
    page: {
      pageType: PAGE_TYPE,
      siteType: getSiteType(deviceType),
      extra: {
        banner_location: 'ListingAgents',
      },
    },
  });
};
